import { removeArchivoAtPath } from "./temarioTree";

/**
 * @param {object} params
 * @param {boolean} params.contentDisabled
 * @param {string} params.bloqueSeleccionado
 * @param {Record<string, unknown[]>} params.bloquesContenido
 * @param {number[]} params.path
 * @param {number} params.archivoIndex
 * @param {(next: Record<string, unknown[]>) => void} params.setBloquesContenido
 * @param {(msg: string) => void} params.setMensaje
 * @param {string} [params.savedHint]
 */
export function removeArchivoFromTemarioState({
  contentDisabled,
  bloqueSeleccionado,
  bloquesContenido,
  path,
  archivoIndex,
  setBloquesContenido,
  setMensaje,
  savedHint = 'Pulsa "Guardar cambios" para conservar los cambios.',
}) {
  if (contentDisabled || !bloqueSeleccionado) {
    return;
  }
  const lista = bloquesContenido[bloqueSeleccionado] || [];
  const next = removeArchivoAtPath(lista, path, archivoIndex);
  if (!next) {
    setMensaje("⚠️ No se pudo quitar el archivo.");
    return;
  }
  setBloquesContenido({ ...bloquesContenido, [bloqueSeleccionado]: next });
  setMensaje(`✅ Archivo quitado del temario. ${savedHint}`);
}
